import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Changeable, ChangeEventListener } from '@philips-emr/tws-core/lib/component/types';

class FieldList extends ComponentAPI implements Changeable<object[]> {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<object[]>();

  getValue(): object[] {
    return this.state.value;
  }

  setValue(value: object[]): void {
    this.setState({ value });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  getMaxRows(): number {
    return this.state.maxRows;
  }

  setMaxRows(maxRows: number): void {
    this.setState({ maxRows });
  }

}

export default FieldList;
